import Immutable from "immutable";

const initialState = {
    email: "",
    emailErrors: [],
    password: "",
    passwordErrors: [],
    passwordConfirmation: "",
    passwordConfirmationErrors: [],
    firstName: "",
    firstNameErrors: [],
    lastName: "",
    lastNameErrors: [],
    phoneNumber: "",
    phoneNumberErrors: [],
    danceSchool: "",
    danceSchoolErrors: [],
    signing: false,
    signingFailed: false,
    signingError: "",
    signingCompleted: false,
    formErrorsVisible: false,
    confirmingEmail: false,
    confirmingEmailFailed: false,
    confirmingEmailError: "",
    confirmingEmailCompleted: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_SIGN_UP_EMAIL":
            return Immutable
                .fromJS(state)
                .set("email", action.value)
                .set("emailErrors", action.errors)
                .toJS();
        case "UPDATE_SIGN_UP_PASSWORD":
            return Immutable
                .fromJS(state)
                .set("password", action.value)
                .set("passwordErrors", action.errors)
                .toJS();
        case "UPDATE_SIGN_UP_PASSWORD_CONFIRMATION":
            return Immutable
                .fromJS(state)
                .set("passwordConfirmation", action.value)
                .set("passwordConfirmationErrors", action.errors)
                .toJS();
        case "UPDATE_SIGN_UP_FIRST_NAME":
            return Immutable
                .fromJS(state)
                .set("firstName", action.value)
                .set("firstNameErrors", action.errors)
                .toJS();
        case "UPDATE_SIGN_UP_LAST_NAME":
            return Immutable
                .fromJS(state)
                .set("lastName", action.value)
                .set("lastNameErrors", action.errors)
                .toJS();
        case "UPDATE_SIGN_UP_PHONE_NUMBER":
            return Immutable
                .fromJS(state)
                .set("phoneNumber", action.value)
                .set("phoneNumberErrors", action.errors)
                .toJS();
        case "UPDATE_SIGN_UP_DANCE_SCHOOL":
            return Immutable
                .fromJS(state)
                .set("danceSchool", action.value)
                .set("danceSchoolErrors", action.errors)
                .toJS();
        case "UPDATE_SIGN_UP_TERMS":
            return Immutable
                .fromJS(state)
                .set("terms", action.value)
                .set("termsErrors", action.errors)
                .toJS();
        case "SIGN_UP_PENDING":
            return Immutable
                .fromJS(state)
                .set("signing", true)
                .set("signingFailed", false)
                .set("signingError", "")
                .toJS();
        case "SIGN_UP_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("signing", false)
                .set("signingCompleted", true)
                .toJS();
        case "SIGN_UP_REJECTED":
            return Immutable
                .fromJS(state)
                .set("signing", false)
                .set("signingFailed", true)
                .set("signingError", action.payload.response.data.message)
                .toJS();
        case "INIT_SIGN_UP_FORM":
            return Immutable
                .fromJS(state)
                .set("email", action.email)
                .set("emailErrors", action.emailErrors)
                .set("password", action.password)
                .set("passwordErrors", action.passwordErrors)
                .set("passwordConfirmation", action.passwordConfirmation)
                .set("passwordConfirmationErrors", action.passwordConfirmationErrors)
                .set("firstName", action.firstName)
                .set("firstNameErrors", action.firstNameErrors)
                .set("lastName", action.lastName)
                .set("lastNameErrors", action.lastNameErrors)
                .set("phoneNumber", action.phoneNumber)
                .set("phoneNumberErrors", action.phoneNumberErrors)
                .set("danceSchool", action.danceSchool)
                .set("danceSchoolErrors", action.danceSchoolErrors)
                .set("terms", action.terms)
                .set("termsErrors", action.termsErrors)
                .set("formErrorsVisible", false)
                .set("signingCompleted", false)
                .toJS();
        case "DISPLAY_SIGN_UP_VALIDATION_ERRORS":
            return Immutable
                .fromJS(state)
                .set("formErrorsVisible", true)
                .toJS();
        case "CONFIRM_EMAIL_PENDING":
            return Immutable
                .fromJS(state)
                .set("confirmingEmail", true)
                .set("confirmingEmailFailed", false)
                .set("confirmingEmailError", "")
                .toJS();
        case "CONFIRM_EMAIL_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("confirmingEmail", false)
                .set("confirmingEmailCompleted", true)
                .toJS();
        case "CONFIRM_EMAIL_REJECTED":
            return Immutable
                .fromJS(state)
                .set("confirmingEmail", false)
                .set("confirmingEmailFailed", true)
                .set("confirmingEmailError", action.payload.response.data.message)
                .toJS();
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/signUp.js